// extracted by mini-css-extract-plugin
export default {"wrap":"QueryBar_wrap__M+6lh","button":"QueryBar_button__Ly6Eb"};